// Lib
import React from 'react';
import { Check } from 'lucide-react';

import { cn } from '@components/lib/utils';

interface SelectableCardProps {
  active: boolean;
  onClick: () => void;
  className?: string;
  children: React.ReactNode;
}

// Shared selectable card used by the size/industry/goals/role selectors.
// Renders a check badge in the top-right corner when active.
export const SelectableCard: React.FC<SelectableCardProps> = ({
  active,
  onClick,
  className,
  children,
}) => (
  <div
    onClick={onClick}
    className={cn(
      'relative flex cursor-pointer items-center gap-6 rounded-xl border bg-card p-3',
      active ? 'border-marble-blue-400 bg-marble-blue-50' : 'border-border',
      className,
    )}
  >
    {active && (
      <div className="absolute -right-1 -top-1 flex size-4 items-center justify-center rounded-full bg-marble-blue-400">
        <Check className="size-3 text-white" />
      </div>
    )}
    {children}
  </div>
);
